<template>
  <div>
    <div
     
    >
      <el-select
        v-model="valuedistrito"
        filterable
        remote
        clearable
        @change="selectDistrito"
        @clear="clearDistrito"
        reserve-keyword
        placeholder="Buscar distrito de edificio"
        no-data-text="No se encontro el distrito"
        :remote-method="remoteMethodDistrito"
        :loading="loadingDistrito"
      >
        <el-option
          class="optionsectores"
          v-for="item in optionsDistrito"
          :key="item"
          :label="item"
          :value="item"
        >
        </el-option>
      </el-select>

      

     
    </div>

    <el-dialog
      title="EDIFICIOS"
      :visible.sync="dialog_edificio"
      close-on-click-modal="false"
      width="40%"
      center
    >
      <div style="text-align: center">
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing">
            <el-tag type="success">DATOS GENERALES</el-tag>
          </el-col>
        </el-row>
      </div>

      <div style="text-align: center">
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroEdificios">Plano: </span>
            <span class="valueClaroEdificios">{{
              dataSelected["PLANO"]
            }}</span></el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroEdificios">Tecnologia: </span>
            <span class="valueClaroEdificios">{{
              dataSelected["TECNOLOGIA"]
            }}</span></el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroEdificios">Distrito: </span
            ><span class="valueClaroEdificios">{{
              dataSelected["DISTRITO"]
            }}</span></el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroEdificios">Departamento: </span
            ><span class="valueClaroEdificios">{{
              dataSelected["DEPARTAMENTO"]
            }}</span></el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroEdificios">Region: </span
            ><span class="valueClaroEdificios">{{
              dataSelected["REGION"]
            }}</span></el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroEdificios">Item: </span
            ><span class="valueClaroEdificios">{{
              dataSelected["ITEM"]
            }}</span></el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroEdificios">Dirección: </span
            ><span class="valueClaroEdificios">{{
              dataSelected["DIRECCION"]
            }}</span></el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroEdificios">Edificio: </span
            ><span class="valueClaroEdificios">{{
              dataSelected["EDIFICIO"]
            }}</span></el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroEdificios">Nombre edificio: </span
            ><span class="valueClaroEdificios">{{
              dataSelected["NOMBRE EDIFICIO"]
            }}</span></el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroEdificios">Nº de pisos: </span
            ><span class="valueClaroEdificios">{{
              dataSelected["N° DE PISOS"]
            }}</span></el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroEdificios">Nº de departamentos: </span
            ><span class="valueClaroEdificios">{{
              dataSelected["N° DE DPTOS"]
            }}</span></el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroEdificios">Oficinas: </span
            ><span class="valueClaroEdificios">{{
              dataSelected["OFICINAS"]
            }}</span></el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroEdificios">Fecha de activación: </span
            ><span class="valueClaroEdificios">{{
              dataSelected["FECHA DE ACTIVACIÓN"]
            }}</span></el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroEdificios">Coordenada domicilio: </span
            ><span class="valueClaroEdificios"
              >{{ dataSelected["Y"] }},{{ dataSelected["X"] }}</span
            ></el-col
          >
        </el-row>
      </div>

      <div style="text-align: center">
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing">
            <el-tag type="success">SERVICIOS RESIDENCIALES</el-tag>
          </el-col>
        </el-row>
      </div>

      <div style="text-align: center">
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroEdificios">Estado: </span>
            <span class="valueClaroEdificios">{{
              dataSelected["ESTADO RESIDENCIAL"]
            }}</span></el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroEdificios">Servicios: </span>
            <span class="valueClaroEdificios">{{
              dataSelected["SERVICIOS RESIDENCIALES"]
            }}</span></el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroEdificios">Maxima capacidad: </span
            ><span class="valueClaroEdificios">{{
              dataSelected["MAXIMA CAPACIDAD"]
            }}</span></el-col
          >
        </el-row>
      </div>

      <div style="text-align: center">
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing">
            <el-tag type="success">SERVICIOS COORPORATIVOS</el-tag>
          </el-col>
        </el-row>
      </div>

      <div style="text-align: center">
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroEdificios">Estado: </span>
            <span class="valueClaroEdificios">{{
              dataSelected["ESTADO CORPORATIVO"]
            }}</span></el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20" :offset="2" class="col-geofencing"
            ><span class="labelClaroEdificios">Servicios: </span>
            <span class="valueClaroEdificios">{{
              dataSelected["SERVICIOS CORPORATIVOS"]
            }}</span></el-col
          >
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
// import dataEdificios from "./edificios/edificios";

export default {
  data() {
    return {
      marker: null,
      isSidenavOpen: "openSidenavSector",
      isSidenavClose: "closedSidenavSector",
      openSidenav: false,
      dataEdificios: dataEdificios,
      optionsDistrito: [],
      optionsAddresses: [],
      dataDistrito: [],
      dataAddresses: [],
      options: [],
      valuedistrito: "",
      valueAddress: "",
      list: [],
      loading: false,
      loadingDistrito: false,
      loadingAddress: false,
      userIsBasic: false,
      userIsAdmin: false,
      userIsIntern: false,
      dataSelected: "",
      dialog_edificio: false,
    };
  },
  computed: {
    ...mapState(["map", "user"]),
  },
  watch: {
    user(newValue, oldValue) {
      console.log("WATCH USER");
      this.userIsBasic = newValue.roles.includes("ROLE_USER");
      this.userIsAdmin = newValue.roles.includes("ROLE_ADMIN");
      this.userIsIntern = newValue.roles.includes("ROLE_CONSULTANT");
      console.log(this.userIsAdmin);
    }
  },
  mounted() {

    let app = this;
    this.$store.watch(this.$store.getters.isOpenSidenav, (openSidenav) => {
      app.openSidenav = openSidenav;
    });

    let distritosOfData = this.dataEdificios.map(
      (edificio) => edificio.DISTRITO
    );

    function onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    }

    this.dataDistrito = distritosOfData.filter(onlyUnique);

    console.log(this.dataDistrito);

  },
  methods: {
    remoteMethodDistrito(query) {
      if (query !== "") {
        this.loadingDistrito = true;

        this.optionsDistrito = this.dataDistrito.filter((item) => {
          return item.toLowerCase().indexOf(query.toLowerCase()) > -1;
        });

        this.loadingDistrito = false;
      } else {
        this.optionsDistrito = [];
      }
    },

    remoteMethodAddresses(query) {
      if (query !== "") {
        this.loadingAddress = true;

        this.optionsAddresses = this.dataAddresses.filter((item) => {
          return item.DIRECCION.toLowerCase().indexOf(query.toLowerCase()) > -1;
        });

        this.loadingAddress = false;
      } else {
        this.optionsAddresses = [];
      }
    },

    selectDistrito(valueDistrito) {
      if (valueDistrito) {
        if (this.marker) {
          this.map.removeLayer(this.marker);
        }

        this.dataAddresses = this.dataEdificios.filter((obj) => {
          return obj.DISTRITO === valueDistrito;
        });0

        console.log(this.dataAddresses);
      }
    },

    selectAddress(valueAddress) {
      if (valueAddress) {
        if (this.marker) {
          this.map.removeLayer(this.marker);
        }

        let dataSelected = this.dataEdificios.find((obj) => {
          return obj.ITEM === valueAddress;
        });

        let long = dataSelected.X;
        let lat = dataSelected.Y;

        let info = dataSelected["N° DE PISOS"];

        this.dataSelected = dataSelected;

        var latlng = L.latLng(lat, long);

        this.marker = L.marker(latlng)
          .addTo(this.map)
          .bindPopup(dataSelected.DIRECCION)
          .openPopup();

        this.map.setView(latlng, 16, {
          duration: 1,
        });

        //this.dialog_edificio = true;
      }
    },

    openDialogEdificio() {
      if (this.dataSelected) {
        this.dialog_edificio = true;
      } else {
        this.$notify.info({
          title: "Info",
          message: "Seleccione una direccion",
        });
      }
    },

    clearDistrito() {
      if (this.marker) {
        this.map.removeLayer(this.marker);
      }

      this.optionsDistrito = [];
      this.dataAddresses = [];
      this.dataSelected = "";
      this.valueAddress = "";
    },

    clearAddress() {
      // this.optionsDistrito = [];
      // this.dataAddresses = [];
      this.dataSelected = "";
      if (this.marker) {
        this.map.removeLayer(this.marker);
      }
    },
  },
};
</script>

<style >
.labelClaroEdificios {
  font-weight: bold;
  font-size: 16px;
}

.valueClaroEdificios {
  font-size: 14px;
  color: #9d0000;
}

.edificios-select {
  top: 55px;
  left: 10px;
  position: fixed;
  -webkit-transition: 0.22s;
  transition: 0.22s;
  z-index: 1000;
}

.select-address {
  width: 80%;
}

.openSidenavSector {
  left: 330px;
  width: 75%;
  display: flex;
  justify-content: start;
}

.closedSidenavSector {
  left: 10px;
  z-index: 999;
  width: 100%;
  display: flex;
  justify-content: start;
}

.el-scrollbar {
  width: 100% !important;
}
</style>